import './dom-53c9635b.js';
import { i as isAncestor } from './isAncestor-2973d4f4.js';

function isPrevented(path, trigger) {
  return path.some(element => {
    const {
      classList
    } = element;
    if (!isAncestor(element, trigger)) {
      if (classList === null || classList === void 0 ? void 0 : classList.contains('or-popover-v3')) {
        return true;
      }
      if (classList === null || classList === void 0 ? void 0 : classList.contains('or-bottom-sheet-v3')) {
        return true;
      }
    }
    return false;
  });
}

export { isPrevented as i };
